import { render, staticRenderFns } from "./basket.vue?vue&type=template&id=b7d15ab8&scoped=true"
import script from "./basket.vue?vue&type=script&lang=js"
export * from "./basket.vue?vue&type=script&lang=js"
import style0 from "./basket.vue?vue&type=style&index=0&id=b7d15ab8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../tmp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d15ab8",
  null
  
)

export default component.exports